import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import dayjs from 'dayjs';
import InfoTooltip from '../InfoTooltip';
import {
  createCategory,
  createDoorList,
  createSpecialAccesss,
  getBnbList,
  updateCleaner,
  updateCleaningReport,
  updateSpecialAccess,
  uploadFile,
} from '../../helper/backend_helper';

const UpdateCleanerReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location?.state?.userData;
  const [moneyFound, setMoneyFound] = useState(userData?.money);
  const [expense, setExpense] = useState(userData?.expense);
  const [cleaningCost, setCleaningCost] = useState(userData?.cleaningCost);
  const [bedSheetCost, setBedsheetCost] = useState(userData?.bedsheetCost);

  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);

      const Categorydata = {
        money: moneyFound,
        expense,
        cleaningCost,
        bedsheetCost: bedSheetCost,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await updateCleaningReport(userData?._id, Categorydata, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Cleaning Report updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Update Cleaner Report </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Update Cleaning Report</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '50ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Money Found <InfoTooltip title="Cash the cleaner found and reported during this cleaning (€), e.g. left behind by guests." /></FormLabel>
              <TextField
                type="number"
                label="Enter"
                id="outlined-size-small"
                value={moneyFound}
                onChange={(e) => setMoneyFound(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Expense <InfoTooltip title="Out-of-pocket cost the cleaner incurred during this job (€), e.g. supplies bought." /></FormLabel>
              <TextField
                type="number"
                label="Enter"
                id="outlined-size-small"
                value={expense}
                onChange={(e) => setExpense(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Cleaning Cost <InfoTooltip title="Amount owed to the cleaner for this cleaning (€). Defaults from the cleaner's rate but can be overridden here." /></FormLabel>
              <TextField
                type="number"
                label="Enter"
                id="outlined-size-small"
                value={cleaningCost}
                onChange={(e) => setCleaningCost(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>BedSheet Cost <InfoTooltip title="Charge for the bed-linen change on this cleaning (€). Defaults from the cleaner's rate but can be overridden here." /></FormLabel>
              <TextField
                type="number"
                label="Enter"
                id="outlined-size-small"
                value={bedSheetCost}
                onChange={(e) => setBedsheetCost(e.target.value)}
              />
            </Stack>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default UpdateCleanerReport;
